import { useEffect, useState } from 'react';

import { LoanBorrowerOptions, loanContractHttp, LoanContractOptions } from '@network';

export const useLoanContractOptions = () => {
  const [options, setOptions] = useState<LoanContractOptions>();
  const [borrowerOptions, setBorrowerOptions] = useState<LoanBorrowerOptions>();

  useEffect(() => {
    (async () => {
      const nextOptions = await loanContractHttp.getOptions();
      setOptions(nextOptions);

      const nextBorrowerOptions = await loanContractHttp.getBorrowerOptions();
      setBorrowerOptions(nextBorrowerOptions);
    })();
  }, []);

  return { options, borrowerOptions };
};
